'use client';
import React from 'react';
import { Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonDynamicSlider from '../CommonDynamicSlider';
import cn from './style.module.scss';
export default function TheResidencesPortfolio(
  props: MarketingPageComponentProps
) {
  const residencesTowerCompilationSlider =
    props?.locale?.section?.residencesTowerCompilationSlider ?? [];
  return (
    <Stack component="section" className={cn.theResidencesPortfolio}>
      <CommonDynamicSlider
        data={residencesTowerCompilationSlider}
        className={cn.makeWorldStoryElement}
      />
    </Stack>
  );
}
